import React, { Component, useState, useEffect } from 'react';
import Nav from "./Nav";

 function Header(){

  const [menuIconState, setMenuIconState] = useState(false);
  const [navMenuState, setNavMenuState] = useState(false);
  const [lightBtnState, setLigthBtnState] = useState(false);

  const MenuIcon = () => {
    setMenuIconState(menuIconState => !menuIconState);
    setNavMenuState(navMenuState => !navMenuState)
  }

const LightBtn = () =>{
    setLigthBtnState(lightBtnState => !lightBtnState);
}

  useEffect(() =>{
    if(lightBtnState == true){
      document.body.classList.add("dark-mode");
    }else{
      document.body.classList.remove("dark-mode");
    }
  })

  let toggleMenuIcon = menuIconState ? "bx bx-x" : "bx bx-menu";
  let toggleNavMenu = navMenuState ? "active" : "";
  let toggleLightBtn = lightBtnState ? "bx bx-sun" : "bx bx-moon"
    // menu icon navbar
    return (
      <div>
        <header class="header">
            <a href="#" class="logo">Portfolio</a>

            <Nav toggleMenu={`${toggleNavMenu}`} MenuIcon={MenuIcon}/>
            <div class={`${toggleLightBtn}`} id="darkMode-icon" onClick={LightBtn}></div>

            <div class={`${toggleMenuIcon}`} id="menu-icon" onClick={MenuIcon}><button></button></div>
        </header>
        </div>
    )
  }

export default Header;
